import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule, RouterOutlet } from '@angular/router';
import { NgbAlertModule, NgbDatepickerModule, NgbModal, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { ApprovalMatrixService } from '../../../Model/ApprovalMatrix/approval-matrix.service';
import { CommonService } from '../../../Model/Common/common.service';
import { IncometaxService } from '../../../Model/Incometax/incometax.service';
import { UserRightService } from '../../../Model/UserRight/user-right.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { AttachmentComponent } from '../../../Component/Attachment/attachment/attachment.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-tax-declaration-preview',
  standalone: true,
  imports: [FormsModule, CommonModule, DataTablesModule, RouterOutlet, RouterModule, NgbDatepickerModule, NgSelectModule, NgbNavModule, NgbAlertModule],
  templateUrl: './tax-declaration-preview.component.html',
  styleUrl: './tax-declaration-preview.component.scss'
})
export class TaxDeclarationPreviewComponent {
  isDisabled: boolean = false;
  active = 1;
  user = [] as any;
  FinancialYears: any[] = [];
  isDataLoad = false;
  DeclarationMessgae = '';
  InvestmentsMessgae = '';
  Filter = {
    ESS_TaxFinancialYearID: null,
    FinancialYearFrom: null as any,
    FinancialYearTo: null as any,
    DeclarationMainID: null as any,
    InvestmentMainID: null as any,
    Declaration_NetTaxableIncome: null,
    Declaration_TaxPaid: null,
    Declaration_TotalTaxPayable: null,
    Declaration_TaxtobePaid: null as any,
    Investment_NetTaxableIncome: null,
    Investment_TaxPaid: null,
    Investment_TotalTaxPayable: null,
    Investment_TaxtobePaid: null as any,
  }

  DTable0 = {
    IsNewRegime: null,
  }

  DTable1 = [
    {
      sectionID: null,
      sectionName: null,
      sectionLimitAblicable: null,
      sectionMaxLimit: null,
      subsections: []
    }
  ] as any; // Chapter XI

  DTable2 = [
    {
      ESS_TaxPreviousEmploymentDetailsID: null,
      ESS_EmpTaxDeclarationID: null,
      Monthname: null,
      Yearname: null,
      Basic: null,
      DA: null,
      HRA: null,
      OtherAllowance: null,
      GrossAmount: null,
      PT: null,
      PF: null,
      TDS: null,
      OtherDeduction: null,
      NetAmount: null,
      Remarks: null
    }
  ];//previews employement

  DTable3 = [{
    ESS_EmpTaxDeclarationDetails_HRAID: null,
    ESS_EmpTaxDeclarationID: null,
    FromDate: null as any,
    ToDate: null as any,
    NameOfLandlord: null,
    LandLordPanNo: null,
    Address: null,
    IsMetroCity: null,
    DeclaredAmount: null as any,
    ApprovedAmount: null as any,
    MonthlyDeclaredAmount: null as any,
    MonthlyApprovedAmount: null as any,
  }]; //Rent house

  DTable4 = [
    {
      sectionID: null,
      sectionName: null,
      sectionLimitAblicable: null,
      sectionMaxLimit: null,
      subsections: []
    }
  ] as any; // Other source of income

  DTable5 = [
    {
      ESS_EmpTaxDeclarationDetails_LOPID: null,
      ESS_EmpTaxDeclarationID: null,
      AnnualRentReceived: null,
      NetAnnualValue: null,
      StandardDeduction: null,
      RepayingHomeLoanForThisProperty: null,
      PrincipalPaidOnHomeLoan: null,
      MunicipalTaxesPaid: null,
      InterestPaidOnHomeLoan: null,
      NameOfTheLender: null,
      LenderPanNo: null,
      NetIncomeLossFromHouseProperty: null,
    }
  ]// let out property

  ETable0 = {
    IsNewRegime: null,
  }

  ETable1 = [
    {
      sectionID: null,
      sectionName: null,
      sectionLimitAblicable: null,
      sectionMaxLimit: null,
      subsections: []
    }
  ] as any; // Chapter XI

  ETable2 = [
    {
      ESS_TaxPreviousEmploymentDetailsID: 0,
      ESS_EmpTaxInvestmentID: 0,
      Monthname: null,
      Yearname: null as any,
      Remarks: null,
      Basic: null as any,
      DA: null as any,
      HRA: null as any,
      OtherAllowance: null as any,
      GrossAmount: 0,
      PT: null as any,
      PF: null as any,
      TDS: null as any,
      OtherDeduction: null as any,
      NetAmount: 0,
      TimeStamp: null,
      ESS_EmpTaxInvestmentPrevEmployment_Attachment: [{
        ESS_EmpTaxInvestmentPrevEmploymentDetailsId: null,
        Attachment: null,
      }
      ],
    }
  ];//previews employement

  ETable3 = [{
    ESS_EmpTaxInvestmentDetails_HRAID: null,
    ESS_EmpTaxInvestmentID: null,
    FromDate: null as any,
    ToDate: null as any,
    NameOfLandlord: null,
    LandLordPanNo: null,
    Address: null,
    IsMetroCity: null,
    ProofSubmissionAmount: null as any,
    ApprovedAmount: null as any,
    ESS_EmpTaxInvestmentDetails_HRAAttachment: [{
      ESS_EmpTaxInvestmentDetails_HRAId: null,
      Attachment: null,
    }],
    MonthlyProofSubmissionAmount: null as any,
    MonthlyApprovedAmount: null as any,
  }]; //Rent house

  ETable4 = [
    {
      sectionID: null,
      sectionName: null,
      sectionLimitAblicable: null,
      sectionMaxLimit: null,
      subsections: []
    }
  ] as any; // Other source of income

  ETable5 = [
    {
      ESS_EmpTaxInvestmentDetails_LOPID: null,
      ESS_EmpTaxInvestmentID: null,
      AnnualRentReceived: null,
      NetAnnualValue: null,
      StandardDeduction: null,
      RepayingHomeLoanForThisProperty: null,
      PrincipalPaidOnHomeLoan: null,
      MunicipalTaxesPaid: null,
      InterestPaidOnHomeLoan: null,
      NameOfTheLender: null,
      LenderPanNo: null,
      NetIncomeLossFromHouseProperty: null,
      ESS_EmpTaxInvestmentDetails_LOPAttachment: [{
        ESS_EmpTaxInvestmentDetails_LOPId: null,
        Attachment: null,
      }]
    }
  ]// let out property

  constructor(
    private approvalMatrix: ApprovalMatrixService,
    private route: ActivatedRoute,
    private session: SessionService,
    private toast: ToastService,
    private router: Router,
    protected common: CommonService,
    private incometax: IncometaxService,
    protected tooltip: TooltipService,
    private userright: UserRightService,
    private modalService: NgbModal,
    protected dateFormat: CustomDateParserFormatter,
  ) {
    this.user = this.session.GetUserDetails();
  }

  ngOnInit(): void {
    this.ESS_TaxFinancialYearSelect();
  }

  FilterValidate(form: any) {
    if (form == null || form.valid) {
      this.Filter.FinancialYearFrom = new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearStart).getFullYear();
      this.Filter.FinancialYearTo = new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getFullYear();
      this.ESS_IncomeTaxSummaryDetailsSelect();
    }
    else {
      form.submitted = true;
    }
  }

  ESS_EmpTaxDeclarationSelect() {
    this.isDisabled = true;
    this.DTable1 = [];
    this.DTable2 = [];
    this.DTable3 = [];
    this.DTable4 = [];
    this.DTable5 = [];
    this.incometax.ESS_EmpTaxDeclarationSelect({ SelectType: 'S', ESS_EmpTaxDeclarationID: this.Filter.DeclarationMainID, EmpMasterId: this.user.UserId, FinancialYearFrom: '', FinancialYearTo: '', IsDraft: false, ApprovalStatus: 'ALL' }).subscribe({
      next: (response) => {
        if (response) {
          if (response.Table && response.Table.length > 0) {
            this.DTable0.IsNewRegime = response.Table[0].IsNewRegime;
            [...new Set(response.Table1.map((e:any) => e.ESS_TaxSectionMasterId))].forEach((element: any) => {
              this.DTable1.push({
                sectionID: response.Table1.filter((e: any) => e.ESS_TaxSectionMasterId == element)[0].ESS_TaxSectionMasterId,
                sectionName: response.Table1.filter((e: any) => e.ESS_TaxSectionMasterId == element)[0].SectionName,
                sectionLimitAblicable: this.DTable0.IsNewRegime ? response.Table1.filter((e: any) => e.ESS_TaxSectionMasterId == element)[0].SectionIsNewMaxlimitapplicable : response.Table1.filter((e: any) => e.ESS_TaxSectionMasterId == element)[0].SectionIsOldMaxlimitapplicable,
                sectionMaxLimit: this.DTable0.IsNewRegime ? response.Table1.filter((e: any) => e.ESS_TaxSectionMasterId == element)[0].SectionNewRegimeMaxAmount : response.Table1.filter((e: any) => e.ESS_TaxSectionMasterId == element)[0].SectionOldRegimeMaxAmount,
                subsections: response.Table1.filter((e: any) => e.ESS_TaxSectionMasterId == element).map(({ SubSectionName, ApprovedAmount, DeclaredAmount, IsNewMaxlimitapplicable, NewRegimeMaxAmount, IsOldMaxlimitapplicable, OldRegimeMaxAmount }: any) => ({
                  SubSectionName,
                  ApprovedAmount,
                  DeclaredAmount,
                  IsNewMaxlimitapplicable,
                  NewRegimeMaxAmount,
                  IsOldMaxlimitapplicable,
                  OldRegimeMaxAmount,
                })),
              });
            });

            this.DTable2 = response.Table2;

            this.DTable3 = response.Table3;
            this.DTable3.forEach(element => {
              element.MonthlyDeclaredAmount = (element.DeclaredAmount / this.getMonthCount(element.FromDate, element.ToDate));
              element.MonthlyApprovedAmount = (element.ApprovedAmount / this.getMonthCount(element.FromDate, element.ToDate));
            });

            [...new Set(response.Table4.map((e:any) => e.ESS_TaxSectionMasterId))].forEach((element: any) => {
              this.DTable4.push({
                sectionID: response.Table4.filter((e: any) => e.ESS_TaxSectionMasterId == element)[0].ESS_TaxSectionMasterId,
                sectionName: response.Table4.filter((e: any) => e.ESS_TaxSectionMasterId == element)[0].SectionName,
                sectionLimitAblicable: this.DTable0.IsNewRegime ? response.Table4.filter((e: any) => e.ESS_TaxSectionMasterId == element)[0].SectionIsNewMaxlimitapplicable : response.Table4.filter((e: any) => e.ESS_TaxSectionMasterId == element)[0].SectionIsOldMaxlimitapplicable,
                sectionMaxLimit: this.DTable0.IsNewRegime ? response.Table4.filter((e: any) => e.ESS_TaxSectionMasterId == element)[0].SectionNewRegimeMaxAmount : response.Table4.filter((e: any) => e.ESS_TaxSectionMasterId == element)[0].SectionOldRegimeMaxAmount,
                subsections: response.Table4.filter((e: any) => e.ESS_TaxSectionMasterId == element).map(({ SubSectionName, ApprovedAmount, DeclaredAmount, IsNewMaxlimitapplicable, NewRegimeMaxAmount, IsOldMaxlimitapplicable, OldRegimeMaxAmount, }: any) => ({
                  SubSectionName,
                  ApprovedAmount,
                  DeclaredAmount,
                  IsNewMaxlimitapplicable,
                  NewRegimeMaxAmount,
                  IsOldMaxlimitapplicable,
                  OldRegimeMaxAmount,
                })),
              });
            });

            this.DTable5 = response.Table5;
          } else {
            this.Filter.DeclarationMainID = 0;
            this.DeclarationMessgae = 'No declaration has been found for the selected financial year';
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_EmpTaxInvestmentSelect() {
    this.isDisabled = true;
    this.ETable1 = [];
    this.ETable2 = [];
    this.ETable3 = [];
    this.ETable4 = [];
    this.ETable5 = [];
    this.incometax.ESS_EmpTaxInvestmentSelect({ SelectType: 'E', ESS_EmpTaxInvestmentID: this.Filter.InvestmentMainID, EmpMasterId: this.user.UserId, FinancialYearFrom: '', FinancialYearTo: '', IsDraft: false, ApprovalStatus: 'ALL' }).subscribe({
      next: (response) => {
        if (response) {
          if (response.Table && response.Table.length > 0) {
            this.ETable0.IsNewRegime = response.Table[0].IsNewRegime;

            if (response.Table1) {
              [...new Set(response.Table1.map((e:any) => e.ESS_TaxSectionMasterId))].forEach((element: any) => {
                this.ETable1.push({
                  sectionID: response.Table1.filter((e: any) => e.ESS_TaxSectionMasterId == element)[0].ESS_TaxSectionMasterId,
                  sectionName: response.Table1.filter((e: any) => e.ESS_TaxSectionMasterId == element)[0].SectionName,
                  sectionLimitAblicable: this.ETable0.IsNewRegime ? response.Table1.filter((e: any) => e.ESS_TaxSectionMasterId == element)[0].SectionIsNewMaxlimitapplicable : response.Table1.filter((e: any) => e.ESS_TaxSectionMasterId == element)[0].SectionIsOldMaxlimitapplicable,
                  sectionMaxLimit: this.ETable0.IsNewRegime ? response.Table1.filter((e: any) => e.ESS_TaxSectionMasterId == element)[0].SectionNewRegimeMaxAmount : response.Table1.filter((e: any) => e.ESS_TaxSectionMasterId == element)[0].SectionOldRegimeMaxAmount,
                  subsections: response.Table1.filter((e: any) => e.ESS_TaxSectionMasterId == element).map(({ ESS_EmpTaxInvestmentDetailsId, SubSectionName, ApprovedAmount, IsNewMaxlimitapplicable, NewRegimeMaxAmount, IsOldMaxlimitapplicable, OldRegimeMaxAmount, ProofSubmissionAmount, }: any) => ({
                    ESS_EmpTaxInvestmentDetailsId,
                    SubSectionName,
                    ApprovedAmount,
                    IsNewMaxlimitapplicable,
                    NewRegimeMaxAmount,
                    IsOldMaxlimitapplicable,
                    OldRegimeMaxAmount,
                    ProofSubmissionAmount
                  })).map((e: any) => ({ ...e, ESS_EmpTaxInvestmentDetails_Attachment: [] })),
                });
              });

              if (response.Table2 && response.Table2.length > 0) {
                if (response.Table2[0].ESS_EmpTaxInvestmentDetailsId != null) {
                  this.ETable1.forEach((element: any) => {
                    element.subsections.forEach((subelement: any) => {
                      subelement.ESS_EmpTaxInvestmentDetails_Attachment = response.Table2.filter((e: any) => e.ESS_EmpTaxInvestmentDetailsId == subelement.ESS_EmpTaxInvestmentDetailsId)
                    });
                  });
                }
              }
            }

            if (response.Table3) {
              this.ETable2 = response.Table3.map((e: any) => ({ ...e, ESS_EmpTaxInvestmentPrevEmployment_Attachment: [] }));
              if (response.Table4 && response.Table4.length > 0) {
                if (response.Table4[0].ESS_EmpTaxInvestmentPrevEmploymentDetailsId != null) {
                  this.ETable2.forEach(element => {
                    element.ESS_EmpTaxInvestmentPrevEmployment_Attachment = response.Table4.filter((e: any) => e.ESS_EmpTaxInvestmentPrevEmploymentDetailsId == element.ESS_TaxPreviousEmploymentDetailsID);
                  });
                }
              }
            }

            if (response.Table5) {
              this.ETable3 = response.Table5.map((e: any) => ({ ...e, ESS_EmpTaxInvestmentDetails_HRAAttachment: [] }));
              if (response.Table6 && response.Table6.length > 0) {
                if (response.Table6[0].ESS_EmpTaxInvestmentDetails_HRAId != null) {
                  this.ETable3.forEach(element => {
                    element.ESS_EmpTaxInvestmentDetails_HRAAttachment = response.Table6.filter((e: any) => e.ESS_EmpTaxInvestmentDetails_HRAId == element.ESS_EmpTaxInvestmentDetails_HRAID);
                  });
                }
              }

              this.ETable3.forEach(element => {
                element.MonthlyProofSubmissionAmount = (element.ProofSubmissionAmount / this.getMonthCount(element.FromDate, element.ToDate));
                element.MonthlyApprovedAmount = (element.ApprovedAmount / this.getMonthCount(element.FromDate, element.ToDate));
              });
            }

            if (response.Table7) {
              [...new Set(response.Table7.map((e:any) => e.ESS_TaxSectionMasterId))].forEach((element: any) => {
                this.ETable4.push({
                  sectionID: response.Table7.filter((e: any) => e.ESS_TaxSectionMasterId == element)[0].ESS_TaxSectionMasterId,
                  sectionName: response.Table7.filter((e: any) => e.ESS_TaxSectionMasterId == element)[0].SectionName,
                  sectionLimitAblicable: this.ETable0.IsNewRegime ? response.Table7.filter((e: any) => e.ESS_TaxSectionMasterId == element)[0].SectionIsNewMaxlimitapplicable : response.Table7.filter((e: any) => e.ESS_TaxSectionMasterId == element)[0].SectionIsOldMaxlimitapplicable,
                  sectionMaxLimit: this.ETable0.IsNewRegime ? response.Table7.filter((e: any) => e.ESS_TaxSectionMasterId == element)[0].SectionNewRegimeMaxAmount : response.Table7.filter((e: any) => e.ESS_TaxSectionMasterId == element)[0].SectionOldRegimeMaxAmount,
                  subsections: response.Table7.filter((e: any) => e.ESS_TaxSectionMasterId == element).map(({ ESS_EmpTaxInvestmentDetails_OthersID, SubSectionName, ApprovedAmount, IsNewMaxlimitapplicable, NewRegimeMaxAmount, IsOldMaxlimitapplicable, OldRegimeMaxAmount, ProofSubmissionAmount }: any) => ({
                    ESS_EmpTaxInvestmentDetails_OthersID,
                    SubSectionName,
                    ApprovedAmount,
                    IsNewMaxlimitapplicable,
                    NewRegimeMaxAmount,
                    IsOldMaxlimitapplicable,
                    OldRegimeMaxAmount,
                    ProofSubmissionAmount
                  })).map((e: any) => ({ ...e, ESS_EmpTaxInvestmentDetails_OthersAttachment: [] })),
                });
              });

              if (response.Table8 && response.Table8.length > 0) {
                if (response.Table8[0].ESS_EmpTaxInvestmentDetails_OthersId != null) {
                  this.ETable4.forEach((element: any) => {
                    element.subsections.forEach((subelement: any) => {
                      subelement.ESS_EmpTaxInvestmentDetails_OthersAttachment = response.Table8.filter((e: any) => e.ESS_EmpTaxInvestmentDetails_OthersId == subelement.ESS_EmpTaxInvestmentDetails_OthersID);
                    });
                  });
                }
              }
            }

            if (response.Table9) {
              this.ETable5 = response.Table9.map((e: any) => ({ ...e, ESS_EmpTaxInvestmentDetails_LOPAttachment: [] }));
              if (response.Table10 && response.Table10.length > 0) {
                if (response.Table10[0].ESS_EmpTaxInvestmentDetails_LOPId != null) {
                  this.ETable5.forEach(element => {
                    element.ESS_EmpTaxInvestmentDetails_LOPAttachment = response.Table10.filter((e: any) => e.ESS_EmpTaxInvestmentDetails_LOPId == element.ESS_EmpTaxInvestmentDetails_LOPID);
                  });
                }
              }
            }
          } else {
            this.Filter.InvestmentMainID = 0;
            this.InvestmentsMessgae = 'No investment has been found for the selected financial year';
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  getMonthCount(startDateStr: string, endDateStr: string): number {
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);

    let months = (endDate.getFullYear() - startDate.getFullYear()) * 12;
    months += endDate.getMonth() - startDate.getMonth();
    if (endDate.getDate() < startDate.getDate()) {
      months--;
    }

    if (months == 0) {
      months++;
    }
    return months;
  }

  attachmentPopup(index: number, tabNo: number, J = 0) {
    const modalRef = this.modalService.open(AttachmentComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
    });
    modalRef.componentInstance.IsView = true;
    if (tabNo == 1 && this.ETable2[index].ESS_EmpTaxInvestmentPrevEmployment_Attachment.length > 0) {
      modalRef.componentInstance.Attachments = this.ETable2[index].ESS_EmpTaxInvestmentPrevEmployment_Attachment.map(e => ({ 'FileName': e['Attachment'], 'Url': this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ProofAttachment + '/' + e['Attachment'] }));
    } else if (tabNo == 2 && this.ETable1[index].subsections[J].ESS_EmpTaxInvestmentDetails_Attachment.length > 0) {
      modalRef.componentInstance.Attachments = this.ETable1[index].subsections[J].ESS_EmpTaxInvestmentDetails_Attachment.map((e: any) => ({ 'FileName': e['Attachment'], 'Url': this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ProofAttachment + '/' + e['Attachment'] }));
    } else if (tabNo == 3 && this.ETable3[index].ESS_EmpTaxInvestmentDetails_HRAAttachment.length > 0) {
      modalRef.componentInstance.Attachments = this.ETable3[index].ESS_EmpTaxInvestmentDetails_HRAAttachment.map(e => ({ 'FileName': e['Attachment'], 'Url': this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ProofAttachment + '/' + e['Attachment'] }));
    } else if (tabNo == 4 && this.ETable5[index].ESS_EmpTaxInvestmentDetails_LOPAttachment.length > 0) {
      modalRef.componentInstance.Attachments = this.ETable5[index].ESS_EmpTaxInvestmentDetails_LOPAttachment.map(e => ({ 'FileName': e['Attachment'], 'Url': this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ProofAttachment + '/' + e['Attachment'] }));
    } else if (tabNo == 5 && this.ETable4[index].subsections[J].ESS_EmpTaxInvestmentDetails_OthersAttachment.length > 0) {
      modalRef.componentInstance.Attachments = this.ETable4[index].subsections[J].ESS_EmpTaxInvestmentDetails_OthersAttachment.map((e: any) => ({ 'FileName': e['Attachment'], 'Url': this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ProofAttachment + '/' + e['Attachment'] }));
    }
    modalRef.result.then((result: any) => { })
  }

  ESS_TaxFinancialYearSelect() {
    this.isDisabled = true;
    this.incometax.ESS_TaxFinancialYearSelect({ SelectType: 'S', ESS_TaxFinancialYearID: null, FinancialYearFrom: null, FinancialYearTo: null }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.FinancialYears = response.Table;
          this.FinancialYears.forEach(element => {
            element.FinancialYear = new Date(element.FinancialYearStart).getFullYear() + ' - ' + new Date(element.FinancialYearEnd).getFullYear();
          });

          this.Filter.ESS_TaxFinancialYearID = this.FinancialYears.filter(e => e.IsActive)[0].ESS_TaxFinancialYearID;
          if (this.Filter.ESS_TaxFinancialYearID != null && this.Filter.ESS_TaxFinancialYearID > 0) {
            this.FilterValidate(null);
          }

        } else {
          this.FinancialYears = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_IncomeTaxSummaryDetailsSelect() {
    this.isDisabled = true;
    this.incometax.ESS_IncomeTaxSummaryDetailsSelect({ SelectType: 'FinalTax', IsActualTax: 1, TaxMainID: 0, EmpmasterID: this.user.UserId, StartYear: this.Filter.FinancialYearFrom, EndYear: this.Filter.FinancialYearTo }).subscribe({
      next: (response) => {
        if (response && response.Table && response.Table.length > 0) {
          this.Filter.DeclarationMainID = response.Table[0].DeclarationMainID;
          this.Filter.InvestmentMainID = response.Table[0].InvestmentMainID;

          this.Filter.Declaration_NetTaxableIncome = response.Table[0].Declaration_NetTaxableIncome;
          this.Filter.Declaration_TaxPaid = response.Table[0].Declaration_TaxPaid;
          this.Filter.Declaration_TotalTaxPayable = response.Table[0].Declaration_TotalTaxPayable;
          this.Filter.Declaration_TaxtobePaid = response.Table[0].Declaration_TotalTaxPayable - response.Table[0].Declaration_TaxPaid;
          this.Filter.Investment_NetTaxableIncome = response.Table[0].Investment_NetTaxableIncome;
          this.Filter.Investment_TaxPaid = response.Table[0].Investment_TaxPaid;
          this.Filter.Investment_TotalTaxPayable = response.Table[0].Investment_TotalTaxPayable;
          this.Filter.Investment_TaxtobePaid = response.Table[0].Investment_TotalTaxPayable - response.Table[0].Investment_TaxPaid;

          if (this.Filter.DeclarationMainID > 0) {
            this.ESS_EmpTaxDeclarationSelect();
          } else {
            this.DeclarationMessgae = 'No declaration has been found for the selected financial year';
          }

          if (this.Filter.InvestmentMainID > 0) {
            this.ESS_EmpTaxInvestmentSelect();
          } else {
            this.InvestmentsMessgae = 'No investment has been found for the selected financial year';
          }

          if (this.Filter.DeclarationMainID == 0 && this.Filter.InvestmentMainID == 0) {
            this.isDisabled = false;
          }

          this.isDataLoad = true;
        } else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = "No Data found";
          modalRef.result.then((result: any) => { });
        }
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  clear() {
    this.isDataLoad = false;
    this.Filter.FinancialYearFrom = null;
    this.Filter.FinancialYearTo = null;
    this.Filter.DeclarationMainID = null;
    this.Filter.InvestmentMainID = null;
    this.Filter.Declaration_NetTaxableIncome = null;
    this.Filter.Declaration_TaxPaid = null;
    this.Filter.Declaration_TotalTaxPayable = null;
    this.Filter.Declaration_TaxtobePaid = null;
    this.Filter.Investment_NetTaxableIncome = null;
    this.Filter.Investment_TaxPaid = null;
    this.Filter.Investment_TotalTaxPayable = null;
    this.Filter.Investment_TaxtobePaid = null;

    this.DTable1 = [];
    this.DTable2 = [];
    this.DTable3 = [];
    this.DTable4 = [];
    this.DTable5 = [];

    this.ETable1 = [];
    this.ETable2 = [];
    this.ETable3 = [];
    this.ETable4 = [];
    this.ETable5 = [];
  }
}
